export default __webpack_public_path__ + "static/media/10.5a5c83ce.jpg";